import React from "react";
//#region types
import { OtherSettingsProps } from "models/propTypes/quotationPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { WizardSection } from "components/common/wintForms";
import { DisplayGroup, MessageGroup, OtherGroup } from "components/invoice";
import DateGroup from "./dateGroup";
import { Grid } from "@mui/material";
import { useInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const OtherSettingsStep: React.FC<OtherSettingsProps> = (props) => {
  const invoiceService = useInvoiceService();
  const { connect, values, submitted, wizardProps } = props;

  const [sellers, setSellers] = React.useState<string[]>();

  React.useEffect(() => {
    invoiceService.getSellers().then((res) => {
      setSellers(res ?? []);
    });
  }, []);

  const hasErrors = connect("otherSettings").hasErrors;
  const contentSummary = !hasErrors
    ? [
        values.otherSettings.invoiceLayout !== undefined
          ? LocalizationHelperInstance.getFormattedMessage(
              `Invoice.InvoiceLayout_${values.otherSettings.invoiceLayout}`
            )
          : undefined,
        values.otherSettings.languageKey !== undefined
          ? LocalizationHelperInstance.getFormattedMessage(
              `Language.${(values.otherSettings.languageKey as string)?.toUpperCase()}`
            )
          : undefined,
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Etc),
      ]
        .filter((s) => s)
        .join(", ")
    : "";

  return (
    <WizardSection
      header={TranslationKeys.Invoice.OtherSettings}
      description={contentSummary ?? TranslationKeys.Quotation.OtherSettingsDescription}
      submitted={submitted}
      hasErrors={hasErrors}
      wizardProps={wizardProps}
    >
      <Grid container direction="column">
        <DateGroup connect={connect} />
        <MessageGroup connect={connect} values={values} isQuotation />
        <DisplayGroup connect={connect} values={values} isQuotation />
        <OtherGroup connect={connect} values={values} isQuotation sellers={sellers} />
      </Grid>
    </WizardSection>
  );
};

export default OtherSettingsStep;
